import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-crop",
  "use": "icon-crop-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-crop\" id=\"icon-crop\"><path d=\"M6.13 1L6 16a2 2 0 0 0 2 2h15\" /><path d=\"M1 6.13L16 6a2 2 0 0 1 2 2v15\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol